import axios, { AxiosResponse } from 'axios';
import { useQuery } from 'react-query';

import { PENDING_TIMESHEETS } from 'api/use-query-constants';
import ReactQueryHook from 'utils/react-query-hook';
import { TimesheetList } from 'features/pending-timesheets/models/pending-timesheets.model';
import { useTrackCotapEvent } from '../../app-insights/track-event.hook';
import { setDisablingSpinnerVisible } from 'redux/global-elements-slice';
import { setPendingTimesheets, setSummaryValues } from 'features/pending-timesheets/redux/pending-timesheets-slice';
import { useDispatch } from 'react-redux';

export interface ITimesheetSummaryResponse {
    hospitalName: string;
    payPeriodEnd: string;
    payPeriodStart: string;
    travelerTimesheetDetails: TimesheetList;
}

export interface IUseTimesheetsQuery {
    isLoading: boolean;
    error?: unknown;
    data?: TimesheetList;
}

const useTimesheets = (url: string, baseUrl: string): ReactQueryHook<TimesheetList> => {
    const trackError = useTrackCotapEvent('TimesheetSummary Error', false);
    const dispatch = useDispatch();

    const { isLoading, error, data }: IUseTimesheetsQuery = useQuery(PENDING_TIMESHEETS, () =>
        axios
            .get(`${baseUrl}/TimesheetApproval/TimesheetSummary?clientOnlineTimesheetApprovalSecret=${url}`)
            .then((response: AxiosResponse<ITimesheetSummaryResponse>) => {
                dispatch(setPendingTimesheets(response?.data.travelerTimesheetDetails));
                dispatch(
                    setSummaryValues({
                        payPeriodStart: response?.data.payPeriodStart,
                        payPeriodEnd: response?.data.payPeriodEnd,
                        hospitalName: response?.data.hospitalName,
                    }),
                );
                return response?.data.travelerTimesheetDetails;
            })
            .catch((e: Error) => {
                trackError({ e });

                throw e;
            })
            .finally(() => {
                dispatch(setDisablingSpinnerVisible(false));
            }),
    );

    return new ReactQueryHook<TimesheetList>(isLoading, error, data);
};

export default useTimesheets;
